import { useField } from 'formik';
import { ticketFieldLabelClass } from '../core/_utils';
import TicketFieldHint from './TicketFieldHint';

type Props = {
  name: string;
  label: string;
  options: string[];
  placeholder?: string;
  required?: boolean;
  help?: string;
};

const TicketSelectField = ({ name, label, options, placeholder = 'Selecione', required = false, help }: Props) => {
  const [field, meta] = useField(name);
  const labelClass = ticketFieldLabelClass(required);
  const id = `ticket-${name}`;
  const error = meta.touched ? meta.error : undefined;

  return (
    <div className="mb-5">
      <label className={labelClass} htmlFor={id}>
        {label}
      </label>
      <select className="form-select form-select-solid" id={id} {...field}>
        <option value="">{placeholder}</option>
        {options.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>
      <TicketFieldHint error={error} help={help} />
    </div>
  );
};

export default TicketSelectField;
